/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {IThorGameData} from "./data/IThorServerData";

export class ThorServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseExtraSymbolsOnTop(rawData:IThorGameData):string[][] {
        return ThorServerDataParser.parseStackedSymbolsInReels(rawData.extraSymbolsOnTop);
    }
}